import { render, staticRenderFns } from "./IdoneitaViewComponent.vue?vue&type=template&id=6d66c8b2"
import script from "./IdoneitaViewComponent.vue?vue&type=script&lang=js"
export * from "./IdoneitaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports